import { api, apiUrl } from './client'

const TOKEN_KEY = 'flowline_token'

export function getStoredToken(): string | null {
  try {
    return localStorage.getItem(TOKEN_KEY)
  } catch {
    return null
  }
}

export function setStoredToken(token: string | null) {
  try {
    if (token) localStorage.setItem(TOKEN_KEY, token)
    else localStorage.removeItem(TOKEN_KEY)
  } catch {
    /* ignore */
  }
}

export interface AuthUser {
  id: string
  email: string
  name: string
  role: string
  workspaceId: string
  permissions?: string[]
}

export async function login(email: string, password: string) {
  const res = await api<{
    token: string
    user: AuthUser
  }>('/api/auth/login', {
    method: 'POST',
    body: JSON.stringify({ email, password })
  })
  setStoredToken(res.token)
  return res
}

export function logout() {
  setStoredToken(null)
}

export async function fetchAuthMe() {
  return api<{
    auth: { actor: string; role: string; via: string; workspaceId: string }
    user: AuthUser | null
    selfSufficient: boolean
  }>('/api/auth/me')
}

export async function fetchBootstrapHint() {
  const res = await fetch(apiUrl('/api/auth/bootstrap-hint'), { headers: { Accept: 'application/json' } })
  return res.json() as Promise<{ defaultEmail: string; hint: string }>
}
